<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                        <kt-form-section>
                            <kt-form-row>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="followup_code">
                                            {{ $t('label.followup_code') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="followup_code"
                                                dir="ltr"
                                                name="followup_code"
                                                id="followup_code"
                                                v-model="query.followup_code"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="merchant_number">
                                            {{ $t('label.merchant_number') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="merchant_number"
                                                name="merchant_number"
                                                id="merchant_number"
                                                v-model="query.merchant_number"
                                                dir="ltr"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="terminal_number">
                                            {{ $t('label.terminal_number') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="terminal_number"
                                                dir="ltr"
                                                name="terminal_number"
                                                id="terminal_number"
                                                v-model="query.terminal_number"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group ref="statusSelectGroup">
                                        <kt-form-label for="status">
                                            {{ $t('label.status') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="status" class="form-control" name="status" v-model="query.status">
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(status, index) in statuses"
                                                    v-bind:value="status.value"
                                                    :selected="query.status === status.value"
                                            >
                                                {{ status.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="website_address">
                                            {{ $t('label.website_address') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="website_address"
                                                dir="ltr"
                                                name="website_address"
                                                id="website_address"
                                                v-model="query.website_address"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="full_name">
                                            {{ $t('label.User_full_name') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="full_name"
                                                dir="rtl"
                                                name="full_name"
                                                id="full_name"
                                                v-model="query.user_full_name"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="ref_farsi_name">
                                            {{ $t('label.ref_farsi_name') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="ref_farsi_name"
                                                dir="rtl"
                                                name="ref_farsi_name"
                                                id="ref_farsi_name"
                                                v-model="query.ref_farsi_name"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="gateway_type">
                                            {{ $t('label.gateway_type') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="gateway_type" class="form-control" name="gateway_type" v-model="query.gateway_type">
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(gateway_type, index) in gatewayTypes"
                                                    v-bind:value="gateway_type.value"
                                                    :selected="query.gateway_type === gateway_type.value"
                                            >
                                                {{ gateway_type.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="ref_id">
                                            {{ $t('label.ref_id') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="ref_id"
                                                dir="rtl"
                                                name="ref_id"
                                                id="ref_id"
                                                v-model="query.ref_id"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="type">
                                            {{ $t('label.type') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="type" class="form-control" name="type" v-model="query.type">
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(type, index) in types"
                                                    v-bind:value="type.value"
                                                    :selected="query.type === type.value"
                                            >
                                                {{ type.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="gateway_status">
                                            {{ $t('label.psp') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="psp" class="form-control" name="psp" v-model="query.psp">
                                            <option
                                                v-bind:key="index"
                                                v-for="(psp_name, index) in psp_names"
                                                v-bind:value="psp_name.value"
                                                :selected="query.psp === psp_name.value"
                                            >
                                                {{ psp_name.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                        </kt-form-section>
                        <kt-form-section>
                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                        </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import $ from 'jquery'
import { i18n } from '@/plugins/i18n'
import { userStatusStr, userStatus } from '@/constants/userStatus'
import { gatewayStatusStr, gatewayStatus } from '@/constants/gatewayStatus'
import {pspName, pspNameStr, pspRequestStatus, pspRequestStatusStr, pspRequestType, pspRequestTypeStr} from "../../../constants/pspRequestStatus";

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            gatewayTypes: [
                {
                    name: null,
                    value: null
                },
                {
                    name: i18n.t('gateway.gateway_types.business'),
                    value: 2
                },
                {
                    name: i18n.t('gateway.gateway_types.business_psp_settlement'),
                    value: 4
                }
            ],
            statuses: [
                {
                    name: null,
                    value: null
                },
                {
                    name: pspRequestStatusStr.SUCCESS,
                    value: pspRequestStatus.SUCCESS
                },
                {
                    name: pspRequestStatusStr.PENDING,
                    value: pspRequestStatus.PENDING
                },
                {
                    name: pspRequestStatusStr.FAIL,
                    value: pspRequestStatus.FAIL
                },
                {
                    name: pspRequestStatusStr.END,
                    value: pspRequestStatus.END
                }
            ],
            types: [
                {
                    name: null,
                    value: null
                },
                {
                    name: pspRequestTypeStr.CREATE_TERMINAL,
                    value: pspRequestType.CREATE_TERMINAL
                },
                {
                    name: pspRequestTypeStr.CHANGE_SHEBA,
                    value: pspRequestType.CHANGE_SHEBA
                },
            ],
            psp_names: [
                {
                    name: '',
                    value: ''
                },
                {
                    name: pspNameStr.mellat,
                    value: pspName.mellat
                },
                {
                    name: pspNameStr.novin,
                    value: pspName.novin
                },
                {
                    name: pspNameStr.saman,
                    value: pspName.saman
                },
                {
                    name: pspNameStr.pasargad,
                    value: pspName.pasargad
                },
                {
                    name: pspNameStr.irankish,
                    value: pspName.irankish
                },
                {
                    name: pspNameStr.asanpardakht,
                    value: pspName.asanpardakht
                },
                {
                    name: pspNameStr.sepehr,
                    value: pspName.sepehr
                },
            ],
            query: {},
        }
    }
}
</script>

<style>

</style>